import React from 'react';
import Container from '../../layout/Container';

const Clients = () => {
  const clients = [
    { 
      name: 'Porto do Itaqui', 
      logo: '/images/clients/porto-itaqui.png' 
    },
    { 
      name: 'UFMA', 
      logo: '/images/clients/ufma.png' 
    },
    { 
      name: 'Ebes Solar', 
      logo: '/images/clients/ebes-solar.png' 
    },
    { 
      name: 'Baites', 
      logo: '/images/clients/baites.png' 
    },
  ];

  return (
    <section className="py-16 md:py-20 relative overflow-hidden bg-gray-950">
      {/* Background sutil */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl" />
      </div>

      <Container>
        {/* Frase impactante */}
        <div className="text-center mb-12 md:mb-16 relative z-10">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 leading-relaxed">
            Empresas que <span className="text-emerald-500">confiam</span> em nossas soluções
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-3xl mx-auto">
            Transformando ideias em realidade para marcas que fazem a diferença
          </p>
        </div>

        {/* Grid de logos */}
        <div className="relative z-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 items-center justify-items-center max-w-5xl mx-auto">
            {clients.map((client, index) => (
              <div
                key={index}
                className="flex items-center justify-center w-full h-20 md:h-24 transition-all duration-500 hover:scale-110 group"
              >
                {/* Placeholder para logo - substitua com suas imagens */}
                <div className="w-full h-full flex items-center justify-center opacity-40 group-hover:opacity-70 transition-opacity duration-500">
                  {client.logo ? (
                    <img
                      src={client.logo}
                      alt={client.name}
                      className="max-w-full max-h-full object-contain grayscale"
                      style={{ filter: 'brightness(0) invert(1)' }}
                    />
                  ) : (
                    <span className="text-gray-600 text-sm font-semibold text-center px-4">
                      {client.name}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Clients;